<template>
    <div class="input-group">
        <span class="input-group-text text-body px-3">
            <slot name="prepend"></slot>
        </span>
        <slot></slot>
        <slot name="append"></slot>
    </div>
</template>
